import React from "react";
import icon_shaprator from "../../asset/images/icon_saprator_header.png"
export default function Footer(){
    return(
        <div className={"footer_main_section"}>
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-md-9"}>
                        <ul className={"footer_details"}>
                            <li className={"single_item"}>
                                <p className={"call_me"}>Call me:</p>
                                <p className={"number"}> <a style={{color:"#796ed2"}} href="tel:9428546783">9428546783</a></p>
                            </li>
                            <li className={"single_item"}>
                                <p className={"call_me"}>Email:</p>
                                <p className={"number"}><a style={{color:"#796ed2"}} href="mailto:brijeshlathiya8586@gmail.com">brijeshlathiya8586@gmail.com</a></p>
                            </li>
                            <li className={"single_item"}>
                                <p className={"call_me"}>Location:</p>
                                <p className={"number"}>India</p>
                            </li>
                        </ul>
                    </div>
                    <div className={"col-md-3 footer_img text-end"}>
                        <img src={icon_shaprator} alt="Brijesh lathiya"/>
                    </div>
                </div>
            </div>
        </div>
    )
}